<template>
    <div>
        <b-modal
            v-model="isModalOpen"
            dialog-class="klippa-data-application-modal"
            hide-footer size="xl"
            title="Erkannte Informationen"
            @hide="reset()">

            <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
                <csp-loading-indicator/>
            </div>
            <b-row v-if="!isLoading">
                <b-col cols="6">
                    <csp-record-data-application-form-preview
                        v-if="fileId"
                        ref="recordDataApplicationFormPreview"
                        :file-id="fileId"
                        :form-fields="formContext.complexFields"
                        :record-id="recordId"/>
                </b-col>
                <b-col cols="6">
                    <csp-desktop-info-card
                        :cols="12"
                        :form-context="formContext"
                        @cancel-form="reset"
                        @save="save">
                        <csp-record-data-application-vehicle-sub-form
                            :form-context="formContext"
                            @field-hover-changed="onFieldHoverChanged"
                            @field-inclusion-changed="onFieldInclusionChanged"/>
                        <csp-record-data-application-customer-sub-form
                            :form-context="formContext"
                            @field-hover-changed="onFieldHoverChanged"
                            @field-inclusion-changed="onFieldInclusionChanged"/>
                        <csp-record-data-application-cost-unit-sub-form
                            :file-id="fileId"
                            :form-context="formContext"
                            :record-id="recordId"
                            @field-hover-changed="onFieldHoverChanged"
                            @field-inclusion-changed="onFieldInclusionChanged"/>
                    </csp-desktop-info-card>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>

import Container from '@services/Container';
import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
import DataApplicationFormPreview from '@desktop/components/record/klippa/DataApplicationFormPreview';
import DataApplicationCostUnitSubForm from '@desktop/components/record/klippa/DataApplicationCostUnitSubForm';
import DataApplicationCustomerSubForm from '@desktop/components/record/klippa/DataApplicationCustomerSubForm';
import DataApplicationVehicleSubForm from '@desktop/components/record/klippa/DataApplicationVehicleSubForm';

const container = Container.getInstance();
const recordRepository = container.getDesktopRecordRepository();

export default {
    name: 'DataApplicationFormModal',
    components: {
        'csp-record-data-application-cost-unit-sub-form': DataApplicationCostUnitSubForm,
        'csp-record-data-application-customer-sub-form': DataApplicationCustomerSubForm,
        'csp-record-data-application-form-preview': DataApplicationFormPreview,
        'csp-record-data-application-vehicle-sub-form': DataApplicationVehicleSubForm,
    },
    mixins: [FormDataMixin],
    props: {
        recordId: {
            type: Number,
            required: true,
        },
        fileId: {
            type: Number,
            default: null,
        },
    },
    emits: ['created', 'reset'],
    data() {
        return {
            excludedFields: {},
            isModalOpen: false,
            isLoading: true,
        }
    },
    computed: {},
    watch: {},
    methods: {
        loadForm() {
            this.isLoading = true;

            const loadFunction = () => {
                return recordRepository.loadDataApplicationForm(this.recordId, this.fileId);
            }
            this.loadFormData(loadFunction).finally(() => {
                this.isLoading = false;
            });
        },
        openModal() {
            this.isModalOpen = true;
            this.loadForm();
        },
        reset() {
            this.formContext.form.reset();
            this.excludedFields = {};
            this.isModalOpen = false;
            this.isLoading = true;

            this.$emit('reset');
        },
        save(formContext) {
            const payload = formContext.form.getData();
            this.filterExcludedFields(payload);

            const saveFunction = (objectId, postData) => {
                return recordRepository.saveDataApplicationForm(this.recordId, this.fileId, postData)
            }

            this.saveFormData(formContext, saveFunction, false).then(() => {
                this.$emit('created');
                this.reset();
            });
        },
        filterExcludedFields(payload) {
            Object.keys(this.excludedFields).forEach((subformKey) => {
                const excluded = this.excludedFields[subformKey];
                const subformAttributes = payload[subformKey]?.data?.attributes;
                if (!subformAttributes) {
                    return;
                }
                excluded.forEach((property) => {
                    delete subformAttributes[property];
                });
            });
        },
        onFieldHoverChanged(data) {
            this.$refs.recordDataApplicationFormPreview.setHoverEffectByFieldIdentifier(
                data.fieldIdentifier,
                data.hovering
            )
        },
        onFieldInclusionChanged(data) {
            this.$refs.recordDataApplicationFormPreview.setVisibilityByFieldIdentifier(
                data.fieldIdentifier,
                data.included
            );

            const subformKey = data.subformIdentifier ?? '';
            if (!this.excludedFields[subformKey]) {
                this.$set(this.excludedFields, subformKey, new Set());
            }
            if (!data.included) {
                this.excludedFields[subformKey].add(data.property);
            } else {
                this.excludedFields[subformKey].delete(data.property);
            }
        },
    },
}
</script>
